module.exports = __webpack_public_path__ + "img/competitiveness-bg2.c6e3a3cb.png";